import {Button, Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {Controller, UseFieldArrayRemove, useFormContext} from "react-hook-form";
import {ProductVariantsFormValues} from "../../types";
import {StyledVariantListItemTopInputAndButtonWrapper} from "../../variant-list-item/styles";
import {DeleteOutlined} from "@ant-design/icons";

type VariantOptionListItemOptionNameFormFieldProps = {
  id: string;
  label: string;
  placeholder?: string;
  variantIndex: number;
  optionIndex: number;
  removeVariantOptionItem: UseFieldArrayRemove;
};

export function VariantOptionListItemOptionNameFormField({
  id,
  label,
  placeholder,
  optionIndex,
  variantIndex,
  removeVariantOptionItem,
}: VariantOptionListItemOptionNameFormFieldProps) {
  const {control} = useFormContext<ProductVariantsFormValues>();
  return (
    <div>
      <StyledVariantListItemTopInputAndButtonWrapper>
        <div className="input-wrapper">
          <FormField
            id={id}
            // label={label}
            renderInput={(id) => (
              <Controller
                control={control}
                name={`variants.${variantIndex}.options.${optionIndex}.name`}
                render={({
                  field: {onChange, value, ref, onBlur},
                  fieldState: {error},
                }) => (
                  <Space size={8} direction="vertical" style={{display: "flex"}}>
                    <Input
                      id={id}
                      status={error?.message ? "error" : ""}
                      onChange={onChange}
                      onBlur={onBlur}
                      size="large"
                      value={value}
                      placeholder="5 templates"
                      ref={ref}
                    />
                    <FormFieldError errorMessage={error?.message} />
                  </Space>
                )}
              />
            )}
          />
        </div>
        {optionIndex !== 0 && (
          <div className="button-wrapper">
            <Button
              onClick={() => removeVariantOptionItem(optionIndex)}
              type="text"
              shape="circle"
              icon={<DeleteOutlined />}
              size="small"
            />
          </div>
        )}
      </StyledVariantListItemTopInputAndButtonWrapper>
    </div>
  );
}
